import { render, staticRenderFns } from "./ReplyPreview.vue?vue&type=template&id=6b8052aa&scoped=true&"
import script from "./ReplyPreview.vue?vue&type=script&lang=js&"
export * from "./ReplyPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReplyPreview.vue?vue&type=style&index=0&id=6b8052aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8052aa",
  null
  
)

export default component.exports